import { Flex, Typography } from '@iheartjane/reefer';
import { Form, useFormContext } from '@iheartjane/reefer-hook-form';
import capitalize from 'lodash-es/capitalize';

import { useSpecialsModal } from '@jane/business-admin/providers/SpecialsModalProvider';
import type { SpecialTypeProps } from '@jane/business-admin/types';
import { ADDITIONAL_WEIGHTS } from '@jane/business-admin/util';

export const BulkPricing = ({
  isCreateMode,
  name,
  options,
}: SpecialTypeProps['bulk_pricing'] & {
  isCreateMode: boolean;
}) => {
  const {
    posSyncMap: { isJanePosSynced, posSynced },
    isReadOnly,
  } = useSpecialsModal();

  const { getValues } = useFormContext();

  const maxApplicationsValue = getValues(`${name}.max_applications_per_cart`);
  const bulkPricingValue = getValues(`${name}.target_weight`);
  const showInputs = (isJanePosSynced || !posSynced) && !isReadOnly;

  return (
    <Flex mb={24} width="100%" flexDirection="column">
      {isCreateMode || (!isCreateMode && showInputs) ? (
        <Flex gap={24}>
          <Flex flexDirection="column" width="100%">
            <Form.NumberField
              name={`${name}.max_applications_per_cart`}
              label="Maximum uses per order"
              min={1}
              disableOnWheel
            />

            <Typography color="grays-mid" mt={16}>
              Limit the number of times this special can be used per order.
            </Typography>
          </Flex>
          <Flex flexDirection="column" width="100%">
            <Form.SelectField
              name={`${name}.target_weight`}
              label="Weight threshold"
              options={options || []}
            />
            <Typography color="grays-mid" mt={16}>
              Select the exact weight the customer must reach to activate this
              special.
            </Typography>
          </Flex>
        </Flex>
      ) : (
        <Flex gap={24}>
          <Flex width="50%" flexDirection="column">
            <Typography
              color="grays-black"
              variant="body-semibold"
              data-testid="non-janepos-synced-max-applications"
            >
              Maximum uses per order
            </Typography>
            <Typography color="grays-black" mt={4}>
              {maxApplicationsValue}
            </Typography>
          </Flex>
          <Flex width="50%" flexDirection="column">
            <Typography
              color="grays-black"
              variant="body-semibold"
              data-testid="non-janepos-synced-weight-threshold"
            >
              Weight threshold
            </Typography>
            <Typography color="grays-black" mt={4}>
              {capitalize(
                ADDITIONAL_WEIGHTS.find(
                  (weight) => weight.id === bulkPricingValue
                )?.label
              )}
            </Typography>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
